import { render, staticRenderFns } from "./NccQuestionCommentBar.vue?vue&type=template&id=c1cbe29c&"
import script from "./NccQuestionCommentBar.vue?vue&type=script&lang=js&"
export * from "./NccQuestionCommentBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/staging.newcitycatechismus.nl/httpdocs/web/app/themes/wp-subsite-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1cbe29c')) {
      api.createRecord('c1cbe29c', component.options)
    } else {
      api.reload('c1cbe29c', component.options)
    }
    module.hot.accept("./NccQuestionCommentBar.vue?vue&type=template&id=c1cbe29c&", function () {
      api.rerender('c1cbe29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/QNA/NccQuestionCommentBar.vue"
export default component.exports